import React from 'react';
import { TrendEnum } from '../../../../constants/budgetPlanned';
import { useThemeContext } from '../../../../global-state/themeContext';
import { TypographyProps } from '../../../../stories/atoms';
import { ContainerV2 } from '../../../../stories/atoms/containerV2/ContainerV2';
import { Direction } from '../../../../theme';
import { calculateColor, calculateIndexValue, calculateTrend } from '../../../../utils/budgetPlanned';
import { StyledTypography, TrendTypography } from './StyledTrendIcon.styles';

type StyledIconProps = {
  originalAmount: number;
  previousAmount: number;
  textOptions?: TypographyProps;
  direction?: Direction;
  fullWidth?: boolean;
  hasPercentage?: boolean;
  hideTrendText?: boolean;
  valueFormatter?: (value: number) => string;
  calculateCustomTrend?: (originalAmount: number, previousAmount: number) => TrendEnum;
};

export const StyledTrendIconComponent: React.FC<StyledIconProps> = ({
  originalAmount,
  previousAmount,
  textOptions,
  direction = 'vertical',
  fullWidth = false,
  hasPercentage = false,
  hideTrendText = false,
  valueFormatter,
  calculateCustomTrend,
}) => {
  const { mode } = useThemeContext();
  const isDarkMode = mode === 'dark';

  const indexValue = calculateIndexValue(originalAmount, previousAmount);

  const trend = calculateCustomTrend
    ? calculateCustomTrend(originalAmount, previousAmount)
    : calculateTrend(originalAmount, previousAmount, false);

  const color = calculateColor(trend, isDarkMode);

  return (
    <ContainerV2
      display="flex"
      flexDirection={direction === 'vertical' ? 'column' : 'row'}
      alignItems="center"
      justifyContent={fullWidth ? 'between' : undefined}
      flexWrap="wrap"
      data-testid="trend-wrapper"
    >
      <StyledTypography
        margin={direction === 'horizontal' ? [0, 1, 0, 0] : undefined}
        type="button"
        {...textOptions}
      >
        {valueFormatter ? valueFormatter(previousAmount) : previousAmount}
        {hasPercentage ? '%' : ''}
      </StyledTypography>
      {!hideTrendText && (
        <TrendTypography data-testid="trend-text-color" trendColor={color}>{`(${indexValue})`}</TrendTypography>
      )}
    </ContainerV2>
  );
};
